import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('mobile')]: {
      padding: [0, theme.spacing(3), theme.spacing(3)],
      maxWidth: 500,
      minWidth: 400,
    },
  },
  field: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  visibilityIcon: {
    fill: theme.palette.colors.teal,
    cursor: 'pointer',
  },
  button: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  form: {
    width: '100%',
  },
  caption: {
    color: theme.palette.colors.gray,
    display: 'flex',
    alignItems: 'center',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/RealEstateAgentRegistrationForm/useStyles.js